
export default {
  en_gb: {
    navbar: {
      logo: 'just-eat-logo',
      logoLink: 'https://partner.just-eat.co.uk/',
      country_toggle: [
        {
          logo: 'dk',
          url: ''
        },
        {
          logo: 'gb',
          url: ''
        }
      ]
    },
    button: {
      text: 'Go home',
      url: 'https://www.just-eat.co.uk'
    },
    content:{
      title:"Everyday savings store-wide",
      paragraph:"",
      subtitle:""
    }
  }
};
